import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const capacity = new RestResource({server: ASSESSMENT_SERVER, resource: 'capacity'});

capacity.byItload = (itload) => {
    let url = `${ASSESSMENT_SERVER}/capacity/byItload/${itload}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default capacity;